import { pageDataKeys } from "~/app/api/pageData";
import { occBaseSiteUrl, occFetch } from "~/app/api/occ/occFetch";
import { occCartUserPath } from "~/app/api/occ/occUserPath";
import { queryClient } from "~/app/queryClient";
import { registerCallProcessor, scheduleCall } from "~/features/cart/cart/api/CartService";

interface DeleteCartCall {
  cartId: string;
}

export function send(cartId: string): Promise<unknown> {
  if (!cartId) {
    return Promise.reject(new Error("Cannot delete a cart without its explicit resource identity"));
  }
  return scheduleCall("deleteCart", { cartId });
}

export async function deleteExplicitCart(cartId: string): Promise<Response> {
  if (!cartId) {
    throw new Error("Cannot delete a cart without its explicit resource identity");
  }
  const response = await occFetch(occBaseSiteUrl(`${occCartUserPath()}/carts/${encodeURIComponent(cartId)}`), {
    method: "DELETE",
  });

  if (!response.ok) {
    throw new Error("Error when clearing cart");
  }

  try {
    await queryClient.invalidateQueries({
      exact: true,
      queryKey: pageDataKeys.session(),
    });
  } catch {
    // Deletion already succeeded. Cache refresh failure must not create a retryable cart mutation.
  }
  return response;
}

registerCallProcessor({
  type: "deleteCart",
  execute: ({ cartId }: DeleteCartCall) => deleteExplicitCart(cartId),
  canBeExecuted: (ongoingCalls) => {
    const areCallsOngoing = ongoingCalls.length > 0;
    return !areCallsOngoing;
  },
});
